import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let current_location = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location',
  })

  return {
    variables: {
      location_id: current_location._id,
      local_start_date: current_location.local_current_date,
    },
  }
}
